import { makeAutoObservable } from 'mobx'

export class PasswordChangeForcePageStore {
  private _title = 'Password Change Force Page'

  constructor() {
    makeAutoObservable(this)
  }

  get title() {
    return this._title
  }
}
